import { render, staticRenderFns } from "./SupplierSelectComponent.vue?vue&type=template&id=4bff86d1&scoped=true"
import script from "./SupplierSelectComponent.vue?vue&type=script&lang=js"
export * from "./SupplierSelectComponent.vue?vue&type=script&lang=js"
import style0 from "./SupplierSelectComponent.vue?vue&type=style&index=0&id=4bff86d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff86d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bff86d1')) {
      api.createRecord('4bff86d1', component.options)
    } else {
      api.reload('4bff86d1', component.options)
    }
    module.hot.accept("./SupplierSelectComponent.vue?vue&type=template&id=4bff86d1&scoped=true", function () {
      api.rerender('4bff86d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supplier-prices/SupplierSelectComponent.vue"
export default component.exports